module.exports = __webpack_public_path__ + "static/media/Irish Fund Board Meeting Agenda.b646bb60.pdf";